import { mantenimientoDescripcion } from "_+_Portal/components/Genericos/MantenimientoCard/MantenimientoTxt";
import {
  AvisoMantenimientoBody,
  AvisoMantenimientoContainer,
  AvisoMantenimientoHeader,
  TopMantenimiento,
} from "./localStyle";

const AvisoMantenimiento = ({onClick}) => {
  return (
    <AvisoMantenimientoContainer>
      <TopMantenimiento><span>Sitio en Mantenimiento</span></TopMantenimiento>
      <AvisoMantenimientoBody>
        <span className="rb18m">{mantenimientoDescripcion}</span>
      </AvisoMantenimientoBody>
    </AvisoMantenimientoContainer>
  );
};

export default AvisoMantenimiento;
